<app-dialog
	modalTitle="{{
		data.mode === 'link' ? 'Vincular' : 'Desvincular'
	}} Organização"
	titleButton="Salvar"
	secTitleButton="Cancelar"
	[secButton]="true"
	[hideFooter]="false"
	(dialogClose)="closeModal()"
	(dialogSave)="saveItems()"
>
	<div class="modal-content-wrapper">
		<p class="dialog-subtitle">
			Selecione uma organização para
			{{ data.mode === 'link' ? 'vincular à' : 'desvincular da' }} corretora
			<strong>{{ data.partner.name }}</strong>
			.
		</p>

		<div *ngIf="isLoading" class="loader">
			<mat-spinner diameter="20"></mat-spinner>
			<span>Carregando...</span>
		</div>

		<ng-container *ngIf="!isLoading">
			<mat-form-field appearance="outline" class="w-100">
				<mat-label>Organização</mat-label>
				<mat-select [formControl]="organizationControl">
					<mat-option
						*ngFor="
							let org of availableOrganizations$ | async;
							trackBy: trackByOrgId
						"
						[value]="org.id"
					>
						{{ org.name_secondary }}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="organizationControl.hasError('required')">
					É necessário selecionar uma organização.
				</mat-error>
			</mat-form-field>

			<div *ngIf="data.mode === 'link'" class="info-box info-box--blue">
				<mat-icon>info_outline</mat-icon>
				<span>
					Apenas organizações que ainda não possuem uma corretora parceira
					vinculada são exibidas.
				</span>
			</div>

			<div *ngIf="data.mode === 'unlink'" class="info-box info-box--orange">
				<mat-icon>warning_amber</mat-icon>
				<span>
					Ao desvincular uma organização, ela ficará sem corretora parceira até
					que seja vinculada novamente.
				</span>
			</div>

			<div
				*ngIf="!isLoading && (availableOrganizations$ | async)?.length === 0"
				class="info-text"
			>
				Nenhuma organização disponível para esta ação.
			</div>
		</ng-container>
	</div>
</app-dialog>
